import Model from './model';

export default Model.extend( {

    endpoint: 'authentication',
    
    defaults: {
        login: '',
        secretString: '',
        phone: undefined,
        code: undefined,
        action: 'post'
    }
    
} );


// WEBPACK FOOTER //
// ./src/js/model/auth.js